import {Component} from "@angular/core";

@Component({
    selector: "fui-chrome-branding",
    styleUrls: ["./chrome-branding.component.scss"],
    templateUrl: "chrome-branding.component.html",
    standalone: false
})
export class FUIChromeBrandingComponent {

}
